import { ReportsSchoolPreferencesComponent } from './reports-school-preferences.component';
import { ReportsSchoolSearchComponent } from '../components/reports-school-search.component';
import { ReportsSchoolPreferencesRowComponent } from './reports-school-preferences-row.component';

export const containers: any[] = [
  ReportsSchoolPreferencesComponent,
  ReportsSchoolSearchComponent,
  ReportsSchoolPreferencesRowComponent
];

export * from './reports-school-preferences.component';
export * from '../components/reports-school-search.component';
export * from './reports-school-preferences-row.component';
